import React, {useEffect} from 'react';
import {useGetCompEventsQuery} from "../../slices/apiSlice";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import {SGP} from "../../pages/Competition/sgp-results-react";

const SeriesSelector = ({onChange = ()=>{} }) => {
    const {data: comps, isSuccess} =
        useGetCompEventsQuery({compType:3})

    const [series, setSeries] = React.useState([])
    const [value, setValue] = React.useState()
    const [initValue, setInitValue] = React.useState()

    useEffect(()=>{
        if (isSuccess) {
            const s = Array.from((new Set(comps.map(c => c.series)))).sort((a,b) => {return  b - a})
            setValue(s[0])
            setInitValue(s[0])
            setSeries(s)
        }
    },[isSuccess])

    const handleChange = (e, el) => {
        const newVal = el.props.value
        setValue(newVal)
        onChange(newVal)
    }

    return (
        <>
            {isSuccess && value &&
                <TextField label="Series" name="series" select defaultValue={initValue}
                           sx={{textAlign: 'left', minWidth: '20em'}}
                           onChange={handleChange}
                >
                    {series.map(s => {
                        return ( s > 0 &&
                            <MenuItem key={s} value={s}>{SGP.getChampionshipTitle({series: s})}{s> initValue ? <sup>*</sup>  : ''}</MenuItem>
                        )
                    })}
                </TextField>
            }
        </>
    );
};

export default SeriesSelector;